import App from "./App";
import { BrowserRouter } from "react-router-dom";

export const Main = () => {
  return (
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};
